import { render, staticRenderFns } from "./preTransferAccountList.vue?vue&type=template&id=8bf8d44c&scoped=true"
import script from "./preTransferAccountList.vue?vue&type=script&lang=ts"
export * from "./preTransferAccountList.vue?vue&type=script&lang=ts"
import style0 from "./preTransferAccountList.vue?vue&type=style&index=0&id=8bf8d44c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf8d44c",
  null
  
)

export default component.exports